import { FC, useMemo } from 'react';
import NotificationsScreensPicker from '../NotificationsScreensPicker/NotificationsScreensPicker';
import { localeStore } from 'src/mobx/localesStore';
import { IPickerOption } from 'src/view/components/Controls/Pickers/Picker/types';

interface IProps {
  options: IPickerOption[];
  selectShortCode: (options: IPickerOption[]) => void;
}

const NotificationShortCodePicker: FC<IProps> = (props: IProps): JSX.Element => {
  const selectedOption = useMemo((): IPickerOption[] => {
    return [{ value: 'add_placeholders', label: localeStore.t('add_placeholders') }];
  }, []);

  return (
    <NotificationsScreensPicker
      title="refund_msg_input_field_label"
      selectedOptions={selectedOption}
      options={props.options}
      onSelectOptions={props.selectShortCode}
      required
    />
  );
};

export default NotificationShortCodePicker;
